import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Slide, Grid, FormControlLabel, Switch } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useUpdateSiteMutation } from '../../services/api';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const EditSiteDialogBox = ({ open, onClose, site, refetch }) => {
    const theme = useTheme();

    const [formData, setFormData] = useState({
        name: '',
        location: '',
        latitude: '',
        longitude: '',
        enabled: false,
    });

    const [updateSite, { isLoading }] = useUpdateSiteMutation();

    // Fetch site data
    useEffect(() => {
        if (site) {
            setFormData({
                name: site.name || '',
                location: site.location || '',
                latitude: site.latitude || '',
                longitude: site.longitude || '',
                enabled: site.enabled || false,
            });
        }
    }, [site]);

    // Hnadle input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // Handle switch change
    const handleSwitchChange = (e) => {
        setFormData((prev) => ({ ...prev, enabled: e.target.checked }));
    };

    // Handle save
    const handleSave = async () => {
        try {
            await updateSite({ siteId: site._id, data: formData }).unwrap();
            refetch();
            onClose();
        } catch (err) {
            console.error('Failed to update site:', err);
        }
    };

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            onClose={onClose}
            aria-describedby="edit-site-dialog-description"
            PaperProps={{
                sx: {
                    backgroundColor: theme.palette.background.paper,
                    width: '600px',
                    padding: theme.spacing(2),
                },
            }}
        >
            <DialogTitle sx={{ color: theme.palette.text.white }} variant="h2" fontWeight="bold">
                Edit Site
            </DialogTitle>

            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField fullWidth margin="dense" label="Name" name="name" value={formData.name} onChange={handleInputChange} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField fullWidth margin="dense" label="Location" name="location" value={formData.location} onChange={handleInputChange} />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField fullWidth margin="dense" label="Latitude" name="latitude" value={formData.latitude} onChange={handleInputChange} />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField fullWidth margin="dense" label="Longitude" name="longitude" value={formData.longitude} onChange={handleInputChange} />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel control={<Switch checked={formData.enabled} onChange={handleSwitchChange} color="primary" />} label="Enabled" />
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions sx={{ padding: theme.spacing(2) }}>
                <Button
                    onClick={onClose}
                    variant="contained"
                    sx={{
                        color: theme.palette.text.black,
                        backgroundColor: theme.palette.text.white,
                        fontWeight: 'bold',
                        '&:hover': {
                            backgroundColor: theme.palette.text.white,
                        },
                    }}
                    disabled={isLoading}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleSave}
                    variant="contained"
                    sx={{
                        color: theme.palette.text.black,
                        backgroundColor: theme.palette.text.white,
                        fontWeight: 'bold',
                        '&:hover': {
                            backgroundColor: theme.palette.text.white,
                        },
                    }}
                    disabled={isLoading}
                >
                    {isLoading ? 'Saving...' : 'Save'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditSiteDialogBox;
